import axios, { InternalAxiosRequestConfig } from "axios";
import config from '../config/config';

export const BASE_URL = config.apiUrl;
export const IMAGE_BASE_URL = config.imageBaseUrl;
export const IMAGE_URL = config.imageBaseUrl;
export const Download_URL = config.fileDownloadUrl;

export const apiClient = axios.create({
  baseURL: BASE_URL,
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    
    if (config.data instanceof FormData) {
      // Let the browser/axios set the Content-Type header with the proper boundary
      // (setting it manually breaks the multipart boundary and causes "Invalid request body" errors)
      if (config.headers && config.headers["Content-Type"]) delete config.headers["Content-Type"];
    } else {
      config.headers["Content-Type"] = "application/json";
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (config.debug) {
      console.error('API Error (interceptor):', error);
    }

    // Reject with the original axios error so callers can inspect `error.response`
    // This preserves full server response (status, data) and stack trace.
    return Promise.reject(error);
  }
);

export default apiClient;
